import Loader from 'components/loader'
import React, {
  useState,
  createContext,
  useContext,
  useRef,
  useEffect,
} from 'react'
import Api from 'utils/api'
import * as authHelper from 'utils/auth-helper'
import { useAgency } from './agency'
import { useAuth } from './auth'

const initLocationContextPropsState = {
  location: undefined,
  setLocation: () => {},
  locations: [],
  setLocations: () => {},
  getLocation: async (selected_location) => {},
  getLocations: async () => {},
}

const LocationContext = createContext(initLocationContextPropsState)

const useLocationInfo = () => {
  return useContext(LocationContext)
}

const LocationProvider = ({ children }) => {
  const [locationKey, setLocationKey] = useState(authHelper.getLocationKey())
  const [location, setLocation] = useState()
  const [locations, setLocations] = useState([])

  const getLocation = async (selected_location) => {
    const { response } = await Api(
      '/location?location_id=' + selected_location,
      'get'
    )
    if (response) {
      setLocation(response.data)
      // setLocationKey(response.data?.api_key)
    } else setLocation({})
  }

  const getLocations = async () => {
    const { response } = await Api('/location/user_locaitons', 'get')
    if (response) {
      setLocations(response.data)
      return response.data || []
    } else setLocations([])
  }
  const saveLocationKey = (locationKey) => {
    setLocationKey(locationKey)
    if (locationKey) authHelper.setLocationKey(locationKey)
  }

  return (
    <LocationContext.Provider
      value={{
        locationKey,
        saveLocationKey,
        location,
        setLocation,
        locations,
        setLocations,
        getLocation,
        getLocations,
      }}
    >
      {children}
    </LocationContext.Provider>
  )
}

const LocationInit = ({ children }) => {
  const { auth, currentUser } = useAuth()
  const { locationKey, locations, saveLocationKey, setLocation } =
    useLocationInfo()
  const { getAgency } = useAgency()
  const { logout } = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  const resetLocationKey = () => {
    const key = locations[0]?.api_key
    saveLocationKey(key)
  }

  useEffect(() => {
    const requestLocation = async () => {
      try {
        console.log(didRequest.current, locationKey)
        if (didRequest.current != locationKey) {
          setShowSplashScreen(true)
          const { response } = await Api('/auth/verify_api_key', 'get')
          if (response) {
            setLocation(response.data)
            await getAgency(response.data?._id)
          }
          // else resetLocationKey()
        }
      } catch (error) {
        console.error(error)
        // resetLocationKey()
        // if (!didRequest.current) {
        // logout()
        // }
      } finally {
        setShowSplashScreen(false)
      }

      didRequest.current = locationKey
    }

    if (auth && locationKey) {
      requestLocation()
    } else {
      // logout()
      setShowSplashScreen(false)
    }
  }, [locationKey])

  useEffect(() => {
    if (auth && currentUser && !locationKey)
      saveLocationKey(currentUser.selected_location)
  }, [auth])

  return showSplashScreen ? (
    <div className='w-full h-[100vh] flex flex-col items-center justify-center'>
      <Loader />
    </div>
  ) : (
    <>{children}</>
  )
}
export { LocationProvider, useLocationInfo, LocationInit }
